import { QuizAnswerValue, QuizQuestionValue } from './quiz-question.value';

export class QuizQuestionValueDto {
    questionText: string;
    answers: QuizAnswerValue[];

    constructor(data: QuizQuestionValue) {
        this.questionText = data.questionText;
        this.answers = data.answers;
    }
}
